@if (isVisible) {
    <div class="d-flex justify-content-between">
        @for (item of omgevingen(); track item.omgeving) {
            <a class="me-2 px-3 py-2 lv-omgeving-item" [class.lv-omgeving-item--active]="item.omgeving === currentOmgeving" [href]="item.url">
                {{ item.omgeving }}
            </a>
        }
    </div>
}
